module.exports = __webpack_public_path__ + "vue-app/img/phone4.0d9ed7a1.svg";